import React from 'react';
import Modal from 'react-modal';
import ReactPlayer from 'react-player';
import { findDOMNode } from 'react-dom';
import ReactDOM from 'react-dom';

const customStyles = {
    overlay: {
      zIndex: 12,
      backgroundColor: 'transparent',
      overflow: 'scroll'
    },
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      height: '50%',
      padding: '0'
    }
  };

class VideoModal extends React.Component {
  constructor(props) {
    super(props);

    this.videoRef = React.createRef();
  }

  render() {
    return (
      <Modal
        isOpen={this.props.modalIsOpen}
        ariaHideApp={false}
        onRequestClose={this.props.closeModal}
        style={customStyles}
        contentLabel="Video Modal"
      >
        <ReactPlayer
          ref={this.videoRef}
          url={this.props.url}
          width="100%"
          height="100%"
          controls={true}
          showControls={true}
          playing={true}
          allowFullScreen={true}
        />
      </Modal>
    )
  }
}

export default VideoModal;
